import React from "react";
import {
    Box,
    Button,
    Menu,
    MenuItem,
    Popover,
    Fade,
    Backdrop,
    AppBar,
    Tabs,
    Tab,
    withStyles,
    Card,
    Dialog,
    CardHeader,
} from "@material-ui/core";
import AssessmentIcon from "@material-ui/icons/Assessment";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import DownloadData from "../DownloadData";
import NotificationsObjective from "../../../Settings/components/NotificationsObjective";
import NotificationsObjectiveList from "../../../Settings/components/NotificationsObjectiveList";
import Screenshots from "../ScreenshotsRebuild";
import BaseElementsPlus from "../BaseElementsPlus";
import Weighted from "../Weighted";
import EventsObjectives from "../EventsObjective";
import Measurements from "../Measurements";
import BaseRegistersPlus from "../BaseRegistersPlus";
import Audios from "../Audios";
import { useTranslation } from 'react-i18next';

const listDisplayAlerts = [1, 2, 5];

const listDisplayCreateAlerts = [1, 5];
const listPlus = [258, 270, 271, 272, 290, 292, 700, 666];

const listIvr = [666];

const styles = {
    customBtn: {
        color: "#fff",
        background: "#909090",
        marginRight: 10,
        marginTop: 5,
        height: "32px",
        fontSize: "13px",
    },
};

function ToolsSection(props) {
    const [toolsEl, setToolsEl] = React.useState(null);
    const [sectionsEl, setSectionEl] = React.useState(null);
    const [downloadEl, setDownloadEl] = React.useState(null);
    const [alertsEl, setAlertsEl] = React.useState(null);
    const [screenshotsEl, setScreenshotsEl] = React.useState(null);
    const [elePlus, setElePlus] = React.useState(null);
    const [weightedEl, setWeightEl] = React.useState(null);
    const [eventsEl, setEventsEl] = React.useState(null);
    const [measurementsEl, setMeasurementsEl] = React.useState(null);
    const [regPlus, setRegPlus] = React.useState(null);
    const [audiosEl, setAudiosEl] = React.useState(null);
    const [value, setValue] = React.useState(0);
    const [updateDisabled, setUpdateDisabled] = React.useState(true);
    const [alertobjectives, setAlertobjectives] = React.useState([]);
    const profile = sessionStorage.getItem("profile") === "Normal";
    const profileId = sessionStorage.getItem("profile_id");
    const displayCreateAlerts = listDisplayCreateAlerts.includes(
        parseInt(profileId)
    );
    const displayAlerts = listDisplayAlerts.includes(parseInt(profileId));
    const { t } = useTranslation();

    const displayEle = listPlus.includes(
        props.location.state.fromObjective.servicio_id
    );

    const displayAudios = listIvr.includes(
        props.location.state.fromObjective.servicio_id
    );

    const handleClickTools = (event) => {
        setToolsEl(event.currentTarget);
    };

    const handleCloseTools = () => {
        setToolsEl(null);
    };

    const handleClickSection = (event) => {
        setSectionEl(event.currentTarget);
    };

    const handleCloseSection = () => {
        setSectionEl(null);
    };

    const handleShowDownload = (event) => {
        setDownloadEl(event.currentTarget);
    };

    const handleCloseDownload = () => {
        setDownloadEl(null);
    };

    const handleShowAlerts = (event) => {
        setAlertsEl(event.currentTarget);
    };

    const handleCloseAlerts = () => {
        setAlertsEl(null);
    };

    const handleChangeUpdate = (newValues) => {
        setValue(2);
        setUpdateDisabled(false);
        setAlertobjectives(newValues);
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleShowScreenshots = (event) => {
        setScreenshotsEl(event.currentTarget);
    };

    const handleCloseScreenshots = () => {
        setScreenshotsEl(null);
    };

    const handleShowElePlus = (event) => {
        setElePlus(event.currentTarget);
    };

    const handleCloseElePlus = () => {
        setElePlus(null);
    };

    const handleShowWeighted = (event) => {
        setWeightEl(event.currentTarget);
    };

    const handleCloseWeighted = () => {
        setWeightEl(null);
    };

    const handleShowEvents = (event) => {
        setEventsEl(event.currentTarget);
    };

    const handleCloseEvents = () => {
        setEventsEl(null);
    };

    const handleShowMeasurements = (event) => {
        setMeasurementsEl(event.currentTarget);
    };

    const handleCloseMeasurements = () => {
        setMeasurementsEl(null);
    };

    const handleShowRegPlus = (event) => {
        setRegPlus(event.currentTarget);
    };

    const handleCloseRegPlus = () => {
        setRegPlus(null);
    };

    const handleShowAudios = (event) => {
        setAudiosEl(event.currentTarget);
    };
    const handleCloseAudios = () => {
        setAudiosEl(null);
    };

    const { classes } = props;

    if (profile) return null;

    return (
        <>
            <Box flex>
                <Button
                    variant="text"
                    onClick={(event) => props.handleClickShowPeriod(event)}
                    value="periodical"
                    className={classes.customBtn}
                >
                    <AssessmentIcon style={{ marginRight: 5 }} />
                    {t('monitoring.tools-section.button.go-to-periodic-reports')}
                </Button>
                <Button
                    aria-controls="tools-menu"
                    aria-haspopup="true"
                    className={classes.customBtn}
                    onClick={handleClickTools}
                >
                    {t('monitoring.tools-section.select.tools.text')}
                    <KeyboardArrowDownIcon style={{ marginLeft: 5 }} />
                </Button>
                <Menu
                    id="tools-menu"
                    anchorEl={toolsEl}
                    keepMounted
                    open={Boolean(toolsEl)}
                    onClose={handleCloseTools}
                >
                    <MenuItem onClick={handleShowDownload}>
                        {t('monitoring.tools-section.select.tools.option.data-download')}
                    </MenuItem>
                    {displayAlerts && (
                        <MenuItem onClick={handleShowAlerts}>
                            {t('monitoring.tools-section.select.tools.option.alerts-config')}
                        </MenuItem>
                    )}
                </Menu>
                <Button
                    aria-controls="sections-menu"
                    aria-haspopup="true"
                    className={classes.customBtn}
                    onClick={handleClickSection}
                >
                    {t('monitoring.tools-section.select.sections.text')}
                    <KeyboardArrowDownIcon style={{ marginLeft: 5 }} />
                </Button>
                <Menu
                    id="sections-menu"
                    anchorEl={sectionsEl}
                    keepMounted
                    open={Boolean(sectionsEl)}
                    onClose={handleCloseSection}
                >
                    <MenuItem onClick={handleShowWeighted}>{t('monitoring.tools-section.select.sections.option.weighted')}</MenuItem>
                    <MenuItem onClick={handleShowEvents}>{t('monitoring.tools-section.select.sections.option.events')}</MenuItem>
                    <MenuItem onClick={handleShowMeasurements}>
                        {t('monitoring.tools-section.select.sections.option.dynamic-measurements-panel')}
                    </MenuItem>
                    {displayEle && (
                        <MenuItem onClick={handleShowRegPlus}>
                            {t('monitoring.tools-section.select.sections.option.plus-records')}
                        </MenuItem>
                    )}
                    {displayAudios && (
                        <MenuItem onClick={handleShowAudios}>
                            {t('monitoring.tools-section.select.sections.option.ivr-audios')}
                        </MenuItem>
                    )}
                </Menu>
                {displayEle && (
                    <Button
                        className={classes.customBtn}
                        onClick={handleShowElePlus}
                    >
                        {t('monitoring.tools-section.button.plus-elements')}
                    </Button>
                )}
                <Button
                    className={classes.customBtn}
                    onClick={handleShowScreenshots}
                >
                    {t('monitoring.tools-section.button.screenshots')}
                </Button>
            </Box>
            {/* Modal Descargar datos */}
            <Popover
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                anchorEl={downloadEl}
                onClose={handleCloseDownload}
                open={Boolean(downloadEl)}
                PaperProps={{
                    style: {
                        borderRadius: "10px",
                    },
                }}
            >
                <DownloadData
                    onClose={handleCloseDownload}
                    period="d"
                    typePeriod={1}
                    typeGraph={6}
                    title={`${t('monitoring.tools-section.download-data.modal.default-title')}:`}
                    id="gauged-h"
                    automaticUpdate={true}
                    size="100%%"
                    textSize="25"
                    dataLabelsY="-35"
                />
            </Popover>
            {/* Modal alertas */}
            <Dialog
                maxWidth="md"
                fullWidth
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={Boolean(alertsEl)}
                onClose={handleCloseAlerts}
                PaperProps={{
                    style: {
                        margin: 4,
                    },
                }}
            >
                <Fade in={Boolean(alertsEl)}>
                    <Card style={{ maxHeight: "100%", overflowY: "auto" }}>
                        <CardHeader
                            title={t('monitoring.tools-section.alerts-config.modal.title')}
                            titleTypographyProps={{ variant: "h4" }}
                            subheader={t('monitoring.tools-section.alerts-config.modal.subtitle')}
                            className="at-blue-background"
                        />
                        <AppBar
                            position="static"
                            style={{ backgroundColor: "#0b1738" }}
                        >
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                aria-label="simple tabs example"
                            >
                                <Tab label={t('monitoring.tools-section.alerts-config.modal.tab.list')} />
                                <Tab
                                    label={t('monitoring.tools-section.alerts-config.modal.tab.add')}
                                    disabled={!displayCreateAlerts}
                                />
                                <Tab label={t('monitoring.tools-section.alerts-config.modal.tab.edit')} disabled={updateDisabled} />
                            </Tabs>
                        </AppBar>
                        {value === 0 ? (
                            <NotificationsObjectiveList
                                params={{ ...props, classes }}
                                onClick={handleChangeUpdate}
                            />
                        ) : value === 1 ? (
                            <NotificationsObjective
                                value={value}
                                alertobjectives={alertobjectives}
                                objective={props.match.params.objetivo_id}
                            />
                        ) : value === 2 ? (
                            <NotificationsObjective
                                value={value}
                                alertobjectives={alertobjectives}
                                objective={props.match.params.objetivo_id}
                            />
                        ) : null}
                    </Card>
                </Fade>
            </Dialog>
            {/* Modal screenshots */}
            <Dialog
                maxWidth="md"
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={Boolean(screenshotsEl)}
                onClose={handleCloseScreenshots}
                PaperProps={{
                    style: {
                        margin: 4,
                    },
                }}
            >
                <Fade in={Boolean(screenshotsEl)}>
                    <Screenshots onClose={handleCloseScreenshots} />
                </Fade>
            </Dialog>
            {/* Elementos Plus */}
            <Dialog
                maxWidth="md"
                fullWidth
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={Boolean(elePlus)}
                onClose={handleCloseElePlus}
                disableAutoFocus={true}
                disableEnforceFocus={true}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={Boolean(elePlus)}>
                    <BaseElementsPlus onClose={handleCloseElePlus} />
                </Fade>
            </Dialog>
            {/* Modal Ponderados */}
            <Dialog
                maxWidth="lg"
                fullWidth
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={Boolean(weightedEl)}
                onClose={handleCloseWeighted}
                disableAutoFocus={true}
                disableEnforceFocus={true}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={Boolean(weightedEl)}>
                    <Weighted onClose={handleCloseWeighted} />
                </Fade>
            </Dialog>
            {/*Modal Eventos */}
            <Dialog
                maxWidth="xl"
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={Boolean(eventsEl)}
                onClose={handleCloseEvents}
                disableAutoFocus={true}
                disableEnforceFocus={true}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={Boolean(eventsEl)}>
                    <EventsObjectives
                        params={props}
                        onClose={handleCloseEvents}
                        title={`${t("monitoring.tools-section.events.modal.title")}: `}
                        period="d"
                        id="gauged-h"
                        automaticUpdate={true}
                        size="100%%"
                        textSize="25"
                        dataLabelsY="-35"
                    />
                </Fade>
            </Dialog>
            {/*Panel Dinamico */}
            <Dialog
                maxWidth="lg"
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={Boolean(measurementsEl)}
                onClose={handleCloseMeasurements}
                disableAutoFocus={true}
                disableEnforceFocus={true}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={Boolean(measurementsEl)}>
                    <Measurements
                        params={props}
                        onClose={handleCloseMeasurements}
                        title={t('monitoring.tools-section.dynamic-measurements-panel.modal.title')}
                        period="d"
                        id="availability-h"
                        typePeriod={1}
                        typeGraph={6}
                        automaticUpdate={true}
                        size="90%"
                        textSize="25"
                        dataLabelsY="-35"
                    />
                </Fade>
            </Dialog>
            {/*Registro Plus */}
            <Dialog
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={Boolean(regPlus)}
                onClose={handleCloseRegPlus}
                disableAutoFocus={true}
                disableEnforceFocus={true}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
                maxWidth='md'
                fullWidth
            >
                <Fade in={Boolean(regPlus)}>
                    <BaseRegistersPlus
                        onClose={handleCloseRegPlus}
                        esIVR={props.location.state.fromObjective.servicio_id === 666}
                    />
                </Fade>
            </Dialog>
            {/* Audios */}
            <Dialog
                maxWidth="md"
                fullWidth
                aria-labelledby="simple-Dialog-title"
                aria-describedby="simple-modal-description"
                open={Boolean(audiosEl)}
                onClose={handleCloseAudios}
                disableAutoFocus={true}
                disableEnforceFocus={true}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={Boolean(audiosEl)}>
                    <Audios onClose={handleCloseAudios} />
                </Fade>
            </Dialog>
        </>
    );
}

export default withStyles(styles)(ToolsSection);
